// extracted by mini-css-extract-plugin
export default {"cta":"FormsObjetivo_cta__u8zF0","erro":"FormsObjetivo_erro__5J4ir"};